import React from 'react'
import { VEC_ICON_NAME } from '../../../../../../components/icons/constants'
import { BUTTON_TYPE } from '../../../../../../components/button/constants'
import ConfirmationPopup from '../../../../../../components/popup/confirmationpopup/ConfirmationPopup'

const InformationModal = ({ isOpen, onCancelCb = () => { }, onSubmitCb = () => { } }) => {
    return (
        <ConfirmationPopup
            title='Are you sure?'
            bodyText='Please confirm you have generated the PDF file before sending it to the eDelivery
portal. You can generate the PDF for all recipients by selecting all recipients and
clicking Download Multiple PDFs, then following the prompts. You can generate the
PDF for a single recipient by using View/Print available under Action for that
recipient. Once the PDF is generated, the Send eDelivery option will permit the
recipient to download their copy.'
            iconName={VEC_ICON_NAME.WARNING_ICON}
            isOpen={isOpen}
            confirmationButtonProps={{
                onConfirmationCb: onSubmitCb,
                confirmationButtonText: "Proceed",
                confirmationButtonStyles: {},
                confirmationButtonType: BUTTON_TYPE.PRIMARY,
            }}
            cancelButtonProps={{
                onCancelCb: onCancelCb,
                cancelButtonText: "Cancel",
                cancelButtonStyles: {},
                cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
            }}
            customStyle={{ minWidth: "800px" }}
        />
    )
}

export default InformationModal
